var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.error && _vm.showError)?_c('div',{staticClass:"error",style:(_vm.width != '' ? 'width: ' + _vm.width + 'px' : '')},[_vm._v(_vm._s(_vm.error.message))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }